// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"67":"0cf973bb","732":"d018e482","870":"61ef4eb8","960":"ae9399b1"}[chunkId] + ".chunk.css";
};